import { Loader } from '@/components/base/Layout/Loader';

const ScreenLoader = () => {
  return (
    <div className="overlay">
      <Loader />
    </div>
  );
};

export default ScreenLoader;
